import { Component, OnInit, Optional, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { requiredModuleError } from '../../../shared/exceptions';
import { BmErrorStateMatcher } from '../../../shared/classes/error-state-matcher';
import { ErrorStateMode } from '../../../shared/enums';
import { GrowUp } from '../../../shared/animations/grow-up';
import { AuthService } from '../../services/auth.service';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';

@Component({
  selector: 'bm-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  animations: [GrowUp]
})

export class LoginFormComponent implements OnInit {

  passwordEncrypted = true;
  isRequesting = false;
  errorMatcher = new BmErrorStateMatcher(ErrorStateMode.OnSubmit);

  @Input() logo: string;

  constructor(
    private dialog: MatDialog,
    private auth: AuthService,
    private fb: FormBuilder,
    @Optional() private router: Router) {

    if (!this.router) {
      requiredModuleError('Router');
    }
  }

  loginForm: FormGroup;

  get email(): FormControl {
    return this.loginForm.get('email') as FormControl;
  }

  get password(): FormControl {
    return this.loginForm.get('password') as FormControl;
  }

  ngOnInit() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      session: [false],
    });
  }

  openForgotPassword() {
    this.dialog.open(ResetPasswordComponent, {
      panelClass: ['cst-mat-dialog']
    });
  }

  login() {
    if (this.loginForm.invalid) {
      return;
    }

    this.isRequesting = true;

    this.auth.login(this.loginForm.value)
    .then(() => this.router.navigate(['/']))
    .finally(() => this.isRequesting = false);
  }

}
